<template>
  <div class="cs-grid">
    <div
      v-for="opt in options"
      :key="opt.value"
      class="cs-card"
      :class="{ active: value === opt.value }"
      @click="select(opt)"
    >
      <div class="cs-card__icon" aria-hidden="true">
        <span />
        <span />
        <span />
      </div>
      <div class="cs-card__name">{{ opt.label }}</div>
      <div class="cs-card__spec">
        <template v-if="opt.loadVolume"> {{ opt.loadVolume }}m³ </template>
        <template v-else> · </template>
      </div>
    </div>
  </div>
</template>

<script>
import { request } from '@/api/service'

export default {
  name: 'ContainerSelect',
  inject: {
    elFormItem: { default: null },
  },
  props: {
    value: { type: String, default: '' },
  },
  data() {
    return {
      options: [],
    }
  },
  mounted() {
    this.loadOptions()
  },
  methods: {
    async loadOptions() {
      const res = await request({
        url: '/factory/masterContainer/select',
        method: 'POST',
      }).catch(() => null)
      if (!res) return
      this.options = res.body.data || []
    },
    select(opt) {
      this.$emit('input', opt.value)
      this.$emit('change', opt)
      if (this.elFormItem) {
        this.elFormItem.validate('change')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.cs-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(92px, 1fr));
  gap: 10px;
}
.cs-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 92px;
  border: 1px solid #d0d5dd;
  border-radius: 10px;
  padding: 12px 8px 10px;
  text-align: center;
  cursor: pointer;
  background: #fff;
  transition: border-color 0.15s, background 0.15s, box-shadow 0.15s;
  &:hover {
    border-color: #98c7ff;
    box-shadow: 0 8px 16px rgba(64, 158, 255, 0.08);
  }
  &.active {
    border-color: #409eff;
    background: #f5f9ff;
    box-shadow: inset 0 0 0 1px rgba(64, 158, 255, 0.15);
  }
  &__icon {
    position: relative;
    display: flex;
    justify-content: center;
    gap: 2px;
    width: 38px;
    height: 24px;
    margin-bottom: 10px;
    padding: 4px 5px;
    border: 1px solid #d0d5dd;
    border-radius: 4px;
    background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
  }
  &__icon span {
    display: block;
    width: 7px;
    height: 14px;
    border-radius: 1px;
    background: #e4e7ec;
  }
  &.active &__icon {
    border-color: #409eff;
    background: #eaf3ff;
  }
  &.active &__icon span {
    background: #8cc2ff;
  }
  &__name {
    font-size: 14px;
    line-height: 20px;
    font-weight: 600;
    color: #344054;
  }
  &__spec {
    margin-top: auto;
    padding-top: 8px;
    font-size: 12px;
    line-height: 18px;
    color: #98a2b3;
  }
}
</style>
